import angular from 'angular'
import moment from 'moment'

export default {
  selectFirst: function selectFirst(values, transformations, valueDefault) {
    for (let idx = 0; idx < values.length; idx++) {
      let value = values[idx]
      for (let tdx = 0; tdx < transformations.length; tdx++) {
        let [checker, transformer] = transformations[tdx]
        if (angular.isDefined(value) && value !== null && checker(value)) {
          return transformer(value)
        }
      }
    }
    return valueDefault
  },
  extractProperties: function extractProperties(object, paths) {
    // When I learn generater syntax, this is the first function I'll rewrite into it.
    const results = []
    for (let pdx = 0; pdx < paths.length; pdx++) {
      let currentPath = paths[pdx]
      let currentPathParts = currentPath.split('.')
      let memoryClone = object
      for (let cdx = 0; cdx < currentPathParts.length; cdx++) {
        let part = currentPathParts[cdx]
        if (Object.prototype.hasOwnProperty.call(memoryClone, part)) {
          memoryClone = memoryClone[part]
        } else {
          memoryClone = undefined
          break
        }
      }
      results.push(memoryClone)
    }
    return results
  },
  isArrayType: function isArrayType(object) {
    return object.constructor === [].constructor
  },
  isDateType: function isDateType(object) {
    if (
      angular.isDefined(object) &&
      object !== null &&
      object.constructor === new Date().constructor
    ) {
      return true
    }
    return false
  },
  isStringType: function isStringType(object) {
    // Consider strings of 0 length as null/undefined
    return angular.isString(object) && object.length > 0
  },
  isMomentType: function isMomentType(object) {
    if (
      angular.isDefined(object) &&
      object !== null &&
      object.constructor === moment().constructor
    ) {
      return true
    }
    return false
  },
  isNull: function isNull(object) {
    return object === null
  },
  ansStringToDateObject: function ansStringToDateObject(ansString) {
    return moment(Date.parse(ansString)).toDate()
  },
  ansStringToDate: function ansStringToDate(ansString) {
    return moment(Date.parse(ansString)).tz(window.org_settings.timezone)
  },
  dataTypeOrNull: function dataTypeOrNull(object, dataTypeChecks) {
    for (let ddx = 0; ddx < dataTypeChecks.length; ddx++) {
      let conditional = dataTypeChecks[ddx]
      if (conditional(object)) {
        return object
      }
    }
    console.debug('unhandled datatype')
    return null
  },
  transformDataTypes: function transformDataTypes(object, transformers) {
    for (let tdx = 0; tdx < transformers.length; tdx++) {
      let [conditional, transformer] = transformers[tdx]
      if (conditional(object)) {
        return transformer(object)
      }
    }
    console.debug('unhandled transformer')
    return null
  },
}
